(function () {
  'use strict';

  var OVERFLOW_TOLERANCE = 2;

  function init(root) {
    var track = root.querySelector('[data-track]');
    var controls = root.querySelector('[data-carousel-controls]');
    if (!track || !controls) return;

    var prev = controls.querySelector('[data-prev]');
    var next = controls.querySelector('[data-next]');
    var fill = controls.querySelector('[data-bar-fill]');

    function gap() {
      var styles = getComputedStyle(track);
      var value = parseFloat(styles.columnGap || styles.gap || '16');
      return isNaN(value) ? 16 : value;
    }

    function step() {
      var firstSlide = track.firstElementChild;
      while (firstSlide && firstSlide.offsetParent === null) {
        firstSlide = firstSlide.nextElementSibling;
      }
      if (!firstSlide) return Math.max(track.clientWidth * 0.8, 240);
      return firstSlide.getBoundingClientRect().width + gap();
    }

    function update() {
      var overflow = track.scrollWidth - track.clientWidth;
      var hasOverflow = overflow > OVERFLOW_TOLERANCE;

      if (!hasOverflow) {
        controls.setAttribute('hidden', '');
        return;
      }
      controls.removeAttribute('hidden');

      if (prev) prev.disabled = track.scrollLeft <= 0;
      if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;

      if (fill) {
        var widthPct = Math.min(100, Math.max(0, (track.clientWidth / track.scrollWidth) * 100));
        var maxLeftPct = 100 - widthPct;
        var progress = overflow > 0 ? track.scrollLeft / overflow : 0;
        var leftPct = Math.min(maxLeftPct, Math.max(0, progress * maxLeftPct));
        fill.style.width = widthPct + '%';
        fill.style.left = leftPct + '%';
      }
    }

    if (prev) {
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });
    }

    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);

    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(update);
      ro.observe(track);
    }

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(update).catch(function () {});
    }

    update();
  }

  function bootstrap() {
    document.querySelectorAll('[data-carousel]').forEach(init);
  }

  document.addEventListener('sentinel:carousel-refresh', bootstrap);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
